import { classes } from "lib/actions/util";
import { UrlObject } from "url";
import Link from "next/link";

type Props = {
  icon?: React.ReactNode;
  title: string;
  href?: UrlObject;
  rightSideSections?: React.ReactNode[];
  bracket?: number;
  titleClass?: string;
};

const MenuItem = ({
  icon,
  title,
  href,
  rightSideSections,
  bracket,
  titleClass = "",
}: Props) => {
  let component = (
    <div
      className={classes(
        "flex items-center justify-between text-sm",
        titleClass,
      )}
    >
      <div className="flex items-center space-x-4 py-3">
        {!!icon && (
          <div className="flex w-6 items-center justify-center text-icon-normal">
            {icon}
          </div>
        )}
        <h2>
          {title}
          {/* {bracket !== undefined && bracket !== null && <span className='text-gray-300'> ({bracket})</span>} */}
        </h2>
      </div>
      {rightSideSections && (
        <div className="flex items-center justify-end divide-x text-xs">
          {rightSideSections.map((section, i) => (
            <div key={i} className="px-1">
              {section}
            </div>
          ))}
        </div>
      )}
    </div>
  );

  if (href)
    component = (
      <div>
        <Link href={href}>{component}</Link>
      </div>
    );

  return component;
};

export default MenuItem;
